<template>
  <v-container
      fluid
  >
    <v-row>
      <v-col cols="12" sm="12" md="12" class="px-0">
      
        <v-card class="pa-5" tile>
          <v-data-table
            class="clickable"
            :headers="headers"
            :loading="loading"
            :items="items"
            :item-class="itemRowBackground"
            :options.sync="options"
            :items-per-page-items="itemsPerPageItems"
            :server-items-length="totalItems"
            @click:row="showDialog"
          >
            <template v-slot:top>
              <v-row>
                <v-col cols="6">
                  <v-text-field
                    v-model="search"
                    append-icon="mdi-folder-search"
                    label="Zoeken"
                    single-line
                    hide-details
                    clearable
                    class="ml-3"
                  ></v-text-field>
                </v-col>
                <v-col cols="6" class="text-right">
                  <v-btn
                    @click="showDialog"
                    color="secondary"
                    class="mr-3"
                    bottom
                  >
                    <v-icon left>mdi-plus</v-icon> {{ $t('Add item') }}
                  </v-btn>
                </v-col>
              </v-row>
            </template>

            <template v-slot:no-results>
              <span>{{ $t('No matching data found') }}</span>
            </template>

            <template v-slot:no-data>
              <span>{{ $t('No data available') }}</span>
            </template>
          </v-data-table>

          <ItemDialog ref="itemDialog" :location-tag="this.location" :location-title="this.stockLocation" @update="fetchItems" />

        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ApiService from '@/services/api.service'
import SessionService from '@/services/session.service'
import ItemDialog from '@/components/StockDialog'
import _ from 'lodash'


export default {
  props: ['location'],
  components: {
    ItemDialog,
  },
  data: () => ({
    items: [],
    totalItems: 10,
    loading: true,
    options: {
        itemsPerPage: 10,
    },
    search: '',
    stockLocation: '',
    itemsPerPageItems: [5, 10, 25, 50],

  }),
  computed: {
    headers() {
      return [
        { text: this.$t('Product name'), value: 'product_name', align: 'left', sortable: true, width: '22%' },
        { text: this.$t('Type'), value: 'type', align: 'left', sortable: true, width: '22%' },
        { text: this.$t('Quantity available'), value: 'quantity_available', align: 'left', sortable: true, width: '22%' },
        { text: this.$t('Quantity threshold'), value: 'quantity_threshold', align: 'left', sortable: true, width: '22%' },
        { text: this.$t('Quantity unit'), value: 'quantity_unit', align: 'left', sortable: true, width: '22%' },
      ]
    },
  },
  watch: {
    'location': function() {
        this.stockLocation = (this.location == 'local' ? 'Pharmacy FTS' : 'Pharmacy')
        this.$store.dispatch('session/title', this.stockLocation)
        this.fetchItems()
    },
    options: {
      handler () {
        this.fetchItems()
      },
      deep: true
    },
    '$i18n.locale': function () {
      this.fetchItems()
      
    },
    search() {
      this.fetchItems()
    },
  },
  created() {   
    if ((this.location !== 'pharmacy') && (this.location !== 'local')) {
        // other names are not allowed, so redirect them to the pharmacy oage instead
        this.$router.push({name:'stock', params:{location:'pharmacy'}});
        return
    }

    this.stockLocation = (this.location == 'local' ? 'Pharmacy Tess' : 'Pharmacy Teams')
    this.$store.dispatch('session/title', this.stockLocation)
    this.restoreFilters()
  },
  methods: {
    itemRowBackground: function (item) {
      return item.quantity_available <= item.quantity_threshold ? 'low-stock' : ''
    },    
    showDialog(item = null) {
      this.$refs.itemDialog.showDialog(item ? item.id : null)
    },
    fetchItems: _.debounce(function() {
      this.loading = true
      this.saveFilters()
      ApiService.index('/stock', this.options, {
        params: {
          filter: {
            location: this.location,   // ('pharmacy' or 'local', set in props (location in url)
            query: this.search,
          },
        },
      }).then(({ items, total })  => {
        this.items = items
        this.totalItems = total
        this.loading = false
      }).catch(() => {
        this.loading = 'error'
      })
    }, 250),
    saveFilters() {
      SessionService.setItem('filter_stock', {
        search: this.search,
        options: this.options,
      })
    },
    restoreFilters() {
      let filters = SessionService.getItem('filter_stock')
      if (filters) {
        this.search = filters.search
        this.options = filters.options
      }
    },
  },
}
</script>

<style scoped>
  >>> .low-stock {
    color: #FF0000 !important
  }
</style>

